<template>
  <!--  testovaci karta 5447380000000006 -->
  <div class="container sidelighted">

    <div class="d-flex blue" style="justify-content: center">
      <img :src="logo_url()" class="cart_logo"/>
    </div>

    <div class="item blue" v-if="step==2 || true">
      <div style="padding-left: 10px">
        <h3>  {{ $t('cart.your_order')}} </h3>
      </div>
      <product-table-kk :items="items" :cart="cart" @changeProduct="changeProduct" v-if="cart.table_template == 'kk'"></product-table-kk>
      <product-table-ll :items="items" :cart="cart" @changeProduct="changeProduct" @refresh-cart="loadCart" v-if="cart.table_template == 'll'"></product-table-ll>
      <product-table-default :items="items" :cart="cart" @changeProduct="changeProduct" v-else></product-table-default>
    </div>

    <div class="blue">
      <div class="title-data">
        <h3>{{ $t('cart.your-details') }}</h3>
      </div>

      <div class="col-md-11" style="padding-left: 48px;">
        <hr>
      </div>

      <div class="item">
        <billing-fields v-if="step==1 || true" :student="student" @billing="handleBillingChange"></billing-fields>
        <div class="shoping-cart-step-2" style="padding-bottom: 50px; padding-left: 10px;" v-if="step==2 || true">
          <div class="wcf-coupon-col-12" style="margin-bottom: 15px">
            <label for="billing_email" class="">{{$t('cart.discount-code')}}<abbr class="required" title="vyžadováno"> </abbr></label>

            <input
                type="text"
                v-model="discount_code"
                class="input-code"
                placeholder="Kód kupónu"
                id="coupon_code"
                value=""
            />

            <button :disabled="!codeIsFilled" type="button" class="code-button" @click.prevent="applyCouponCode">
              {{ $t('cart.apply') }}
            </button>
          </div>

<!--          <div class="col-md-12">-->
<!--            <hr>-->
<!--          </div>-->

          <div class="d-flex" style="margin-bottom:40px;">
            <div style="width: 20px">
              <input type="checkbox" class="checkbox_input" id="conditions-checkbox" v-model="checked"/>
            </div>
            <div>
              <label for="conditions-checkbox"> {{$t('cart.i-have-read')}}</label>
            </div>
            <div>
              <a href="https://www.onlinejazyky.cz/smluvni-podminky.html" target=”_blank”>{{$t('cart.terms-and-conditions')}}</a><br>
            </div>
          </div>

          <div class="row">
            <div>
              <button :disabled="isCheckoutDisabled" @click.prevent="handle_create_order">
                {{ isCreatingOrder ? 'Zpracovávám...' : $t('cart.checkout') }}
              </button>
            </div>
          </div>

        </div><!-- shoping-cart-step-2 -->
      </div><!-- item -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SetPassword from "./set-password.vue";
import CbGr from "./cb-gr.vue";
import ProductTableKk from "./product-table-kk.vue";
import ProductTableDefault from "./product-table-default.vue";
import ProductTableLl from "./product-table-ll.vue";
import BillingFields from "./billing-fields.vue";
import {toast} from "vue3-toastify";
export default {
  props: ["objid"],
  components: { BillingFields, ProductTableDefault, ProductTableKk, SetPassword, CbGr, ProductTableLl},
  name: "shopping-cart",
  data() {
    return {
      step: 1,
      company_box: false,
      items: [],
      billing: {
        email: "",
        first_name: "",
        last_name: "",
        ic: "",
        dic: "",
        dic_dph: "",
        company: "",
        tel:'',
      },

      discount_code: "",
      payment_id: null,

      order_id: null,
      cart: {},
      student:{},
      iframe_gopay_url: null,
      paymentSessionId: null,
      encryptedSignature: null,
      checked: false,
      isCreatingOrder: false,
    };
  },
  computed: {
    fieldsAreFilled() {
      return this.billing.email && this.billing.first_name && this.billing.last_name && this.billing.tel
    },
    codeIsFilled() {
      return this.discount_code
    },
    emailValid(){
      return this.isValidEmail(this.billing.email)
    },
    telValid(){
      return this.isValidTel(this.billing.tel)
    },
    isCheckoutDisabled() {
      return !this.fieldsAreFilled || !this.checked || !this.emailValid || !this.telValid || this.isCreatingOrder
    }
  },

  mounted() {
    window.dataLayer = window.dataLayer || [];
    this.loadCart(this.ga_begin_checkout);
  },
  methods: {



    ga_begin_checkout(){

      console.log("GA begin checkout", this.cart.get_discounted_price );

      // SmartEmailing identify — nutné pro cross-domain session (objednavka.onlinejazyky.cz)
      if (this.cart?.student?.email) {
        window._se = window._se || [];
        window._se.push([
          'identify',
          {
            contact_data: {
              emailaddress: this.cart.student.email
            },
            reidentify: false,
            update_existing: true,
            only_existing: true
          }
        ]);
      }

      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: this.cart.currency_code,
          value: this.cart.get_discounted_price,  // Celková hodnota košíku
          items: this.items.map(item => ({
            item_id: item.product.id,
            item_name: item.product.name,
            price: item.price_with_tax,
            quantity: item.qty
          }))
        }
      });
    },

    ga_add_payment_info(){
      console.log("GA add payment info", this.cart.get_discounted_price );
      window.dataLayer.push({
        event: 'add_payment_info',
        ecommerce: {
          currency: this.cart.currency_code,
          payment_type: 'GoPay',
          value: this.cart.get_discounted_price,  // Celková hodnota košíku
          items: this.items.map(item => ({
            item_id: item.product.id,
            item_name: item.product.name,
            price: item.price_with_tax,
            quantity: item.qty
          }))
        }
      });
    },

    ga_purchase_event(payment, order) {
      console.log("GA purchase event (free order)", payment);
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: order.id_woo || order.id,
          value: 0,
          currency: this.cart.currency_code,
          payment_type: 'Free (Discount Code)',
          items: this.items.map(item => ({
            item_id: item.product.id,
            item_name: item.product.name,
            price: 0,
            quantity: item.qty
          }))
        }
      });
    },


    isValidEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },

    isValidTel(tel) {
      if (!tel) return false;
      // Odstranit mezery, pomlčky, závorky
      const normalized = tel.replace(/[\s\-()]/g, '');
      // Odstranit vše kromě číslic a +
      const digitsAndPlus = normalized.replace(/[^\d+]/g, '');
      // Spočítat pouze čísla (bez +)
      const justNumbers = digitsAndPlus.replace(/\+/g, '');
      // Validovat: minimálně 6 číslic, maximálně 15 číslic
      return justNumbers.length >= 6 && justNumbers.length <= 15;
    },

    logo_url() {
      const onla = `/img/OJ_onlajnovka_logo_tmave_bez_url@2x.png`

      const oj = `/img/OJ_Logo.svg`

      console.log('this.cart.brand', this.cart.brand)

      if (this.cart.brand=='onla') return onla

      if (this.cart.brand=='el') return `/img/logo-el.svg`

      if (this.cart.brand=='oj') return oj
      return ''
    },

    handleProductAdded() {

      this.loadCart()
    },

    handleBillingChange(billing) {
      this.billing = billing;
    },


    handleStep1Submitted(billing){
      this.billing = billing;
      this.step = 2;
    },

    changeProduct(it) {
      console.log('change product', it, it.selected_variant)
      axios.put(`/shopping_cart/change_product/${it.id}`, {
        product_id: it.selected_variant,
        qty: it.qty,
        objid: this.objid,
        lector_id: it.lector_id,
        lesson_minutes: it.lesson_minutes,
      }).then((response) => {
        this.loadCart()
      })
    },

    loadCart(callBack) {
      axios.get(`/shopping_cart/cart`, {params: {objid: this.objid}}).then((response) => {
        this.items = response.data.items;
        this.cart = response.data.cart;
        this.student = response.data.student;

        if (this.step === 1){
          this.student = response.data.student;
        }

        if (callBack && typeof callBack === "function") {
          callBack()
        }

      });
    },

    applyCouponCode() {
      const data = {
        code: this.discount_code,
        objid: this.objid,
        currency: this.cart.currency_code
      }
      axios.post('/shopping_cart/discount-code', data).then((response) => {
        const isDiscountCode = response.data.code && response.data.code.id > 0;
        const isGiftVoucher  = response.data.gift_voucher && response.data.gift_voucher.id > 0;
        if (isDiscountCode || isGiftVoucher) {
          this.loadCart()
          //this.$toasted.success("Kupón byl úspěšně použit", {duration: 5000});
          toast( this.$t("cart.discount-code-ok"), {type: 'success'});
        } else {
          //this.$toasted.error("Neplatný kupón", {duration: 5000});
          toast(  this.$t('cart.invalid-discount-code'), {type: 'error'});
        }
      }).catch((error) => {
        //console.log(error);
        //this.$toasted.error("Neplatný kupón", {duration: 5000});
        toast('Neplatný kupón: '+ error.response.data.error, {type: 'error'});
      });
    },

    handle_create_order() {
      // Prevent multiple submissions
      if (this.isCreatingOrder) {
        return;
      }

      this.isCreatingOrder = true;

      const data = {
        billing: this.billing,
        discount_code: this.discount_code,
        objid: this.objid,
      };
      axios.post(`/shopping_cart/create-order`, data).then((response) => {
        this.payment_id = response.data.payment.id;
        
        // === NOVÁ LOGIKA: Kontrola zda je to nulová platba ===
        if (response.data.free_order === true) {
          // Zobrazit úspěšnou zprávu
          toast(this.$t('cart.order-completed-free'), {
            type: 'success',
            autoClose: 3000
          });
          
          // GA event pro dokončenou objednávku (bez platby)
          if (typeof this.ga_purchase_event === 'function') {
            this.ga_purchase_event(response.data.payment, response.data.order);
          }
          
          // Přesměrovat na success stránku po 2 sekundách
          setTimeout(() => {
            window.location.href = response.data.success_url;
          }, 2000);
          
          return;
        }
        
        // === PŮVODNÍ LOGIKA: GoPay platba ===
        const url = response.data.gopay_url
        if (url) {

          this.ga_add_payment_info()


          //window.location.href = url;
          this.iframe_gopay_url = url
          window._gopay.checkout({gatewayUrl: url, inline: true});
          
          // Keep isCreatingOrder true since we're redirecting to payment
        }
      }).catch((error) => {
        this.isCreatingOrder = false;
        
        console.error('Order creation error:', error);
        
        // Extract user-friendly error message
        let errorMessage = 'Chyba při vytváření objednávky';
        
        if (error.response) {
          // Server responded with error status
          if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.status === 422) {
            errorMessage = 'Neplatná objednávka. Zkontrolujte údaje.';
          } else if (error.response.status === 503) {
            errorMessage = 'Platební služba je dočasně nedostupná. Zkuste to prosím za chvíli.';
          } else if (error.response.status === 502) {
            errorMessage = 'Problém s komunikací s platební bránou. Zkuste to prosím znovu.';
          }
        } else if (error.request) {
          // Request was made but no response received
          errorMessage = 'Spojení se serverem selhalo. Zkontrolujte připojení k internetu.';
        }
        
        toast(errorMessage, {type: 'error', autoClose: 8000});
      });
    },
  },
};
</script>

<style scoped lang="scss">

@media only screen and (max-width: 768px) {
  label {
    text-align: right;
  }
}

label {
  width: 100px;
  text-align: right;
  display: inline-flex;
}

.container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
}

.item {
  flex-grow: 1;
  padding: 10px 10px 0px 10px;
  padding: 50px;
}

.title-data {
  padding-left: 48px;
  padding-top: 40px;
}

.itemFU1 {
  flex-grow: 1;
  padding: 10px 10px 10px 13px;
}

.itemFU2 {
  flex-grow: 1;
  padding: 10px 10px 10px 0px;
}

input {
  background-color: white;
  width: 200px;




padding: 11px 12px;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d4d4d4;
  border-radius: 3px;

}

input:focus {
  //outline: none !important;
  border-color: #37A8D6;
  border-style: solid;
  box-shadow: 0 0 2px #37A8D6;

}

.input-code {
  width: 120px;
}

.code-button {
  background-color: #37A8D6;
  border-radius: 20px;
  border: none;
  padding: 5px 20px 5px 20px;
  height: 28px;
  width: 80px;
  color: white;
  text-align: center;
  font-family: 'Proxima Nova', sans-serif;
  font-size: 0.8rem;
  //font-weight: bold;
  //text-transform: uppercase;
  margin-left: 10px;
  padding: 0px 9px 0px 9px;
}

button {
  background-color: #37A8D6;
  color: white;
  font-size: 1rem;
  border-radius: 20px;
  border: none;
  padding: 5px 20px 5px 20px;
  margin-left: 5px;
  //text-transform: uppercase;
  font-weight: bold;
}

button:disabled,
button[disabled] {
  background-color: lightgrey;
  color: white;
}

select {
  padding: 3px 7px 3px 7px;
}

input[type="checkbox"] {
  width: 10px;
  margin-left: 4px;
}

.shad {
  box-shadow: 0 2px 10px 8px lightgrey;
}

.blue {
  //background-color: #d8f9ff;
  //background-color: #e2f3fb
}

.sidelighted{

  background: url('/img/bg-side-light2.svg') repeat-y;
  background-color: #e2f3fb;
  background-size: contain;
  background-position: left center;
  padding-left:40px;
}


.cart_logo{
  width: 200px;
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

  @media only screen and (max-width: 768px) {
    .cart_logo {
      width: 150px;
    }

    .item{
      padding: 20px 40px;
    }
    .title-data{
      padding-top:0;
    }
  }

.is-invalid{
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.is-valid{
  border-color: #28a745 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
}

</style>
